<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import notificationMixin from 'src/mixins/notificationMixin'
import masterMixin from 'src/mixins/masterMixin'
import shinshukutsugiteApi from 'src/apis/masters/shinshukutsugite'

const api = shinshukutsugiteApi
const displayPageName = '伸縮継手形式'
const msgVars = { create: '作成', update: '編集' }

export default {
  displayPageName: displayPageName,
  data() {
    return {
      displayPageName: displayPageName,

      isReady: false,
      isRequesting: false,

      search: {
        zaishitsuId: null,
      },
      origList: [],
      list: [],
      shinshukutsugiteZaishitsuCands: [],
      saveCandidate: {},
      showSaveModal: false,
      showPasswordModal: false,

      pagination: {
        currentPage: 1,
        itemsPerPage: 50,
      },
    }
  },
  computed: {
    ...mapState('user', {
      has_role_admin: state => state.has_role_admin,
    }),
    hasList() {
      return this.list.length > 0
    },
    paginatedList() {
      const nextPageIdx = this.pagination.currentPage * this.pagination.itemsPerPage
      const minIdx = nextPageIdx - this.pagination.itemsPerPage
      return this.list.filter((e, i) => {
        return i >= minIdx && i < nextPageIdx
      })
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    if (!this.has_role_admin) {
      location.href = '/'
    }

    this.prepareMasters()
    this.prepareSearchParams()
    await this.getList()
    this.isReady = true
  },
  mixins: [notificationMixin, masterMixin],
  methods: {
    prepareMasters() {
      const master = window.master
      this.shinshukutsugiteZaishitsuCands = master.shinshukutsugite_zaishitsu.vals
    },
    prepareSearchParams() {
      const search = {
        zaishitsuId: null,
      }
      if (this.shinshukutsugiteZaishitsuCands.length > 0) {
        search.zaishitsuId = this.shinshukutsugiteZaishitsuCands[0].zaishitsu_id
      }
      this.search = search
    },
    filterListBySearchParams() {
      this.pagination.currentPage = 1
      const shinshukutsugiteZaishitsu = this.shinshukutsugiteZaishitsuCands.find(e => {
        return e.zaishitsu_id === this.search.zaishitsuId
      })
      if (!shinshukutsugiteZaishitsu) { return [] }
      this.list = this.origList.filter(e => {
        return (e.tenkengyoumu_base_id === shinshukutsugiteZaishitsu.tenkengyoumu_base_id) &&
          (e.tenkengyoumu_detail_id === shinshukutsugiteZaishitsu.tenkengyoumu_detail_id) &&
          (e.tenkenkubun_id === shinshukutsugiteZaishitsu.tenkenkubun_id) &&
          (e.zaishitsu_id === shinshukutsugiteZaishitsu.zaishitsu_id)
      })
    },
    async getList() {
      this.isRequesting = true
      try {
        const { data } = await shinshukutsugiteApi.index()
        this.origList = data
        this.filterListBySearchParams()
        this.isRequesting = false
      } catch (err) {
        console.error('error', err)
        this.isRequesting = false
      }
    },
    openSaveModal(item) {
      let saveCandidate = {}
      if (!item) {
        saveCandidate.isNew = true
        saveCandidate.zaishitsu_id = this.search.zaishitsuId
        const shinshukutsugiteZaishitsu = this.shinshukutsugiteZaishitsuCands.find(e => {
          return e.zaishitsu_id === this.search.zaishitsuId
        })
        saveCandidate.tenkengyoumu_base_id = shinshukutsugiteZaishitsu.tenkengyoumu_base_id
        saveCandidate.tenkengyoumu_detail_id = shinshukutsugiteZaishitsu.tenkengyoumu_detail_id
        saveCandidate.tenkenkubun_id = shinshukutsugiteZaishitsu.tenkenkubun_id
        saveCandidate.zaishitsu_id = shinshukutsugiteZaishitsu.zaishitsu_id
        saveCandidate.zaishitsu_nm = shinshukutsugiteZaishitsu.zaishitsu_nm
      } else {
        saveCandidate = JSON.parse(JSON.stringify(item))
      }
      this.saveCandidate = saveCandidate
      this.showSaveModal = true
    },
    closeSaveModal() {
      this.saveCandidate = {}
      this.showSaveModal = false
    },
    async saveItem() {
      const isValid = await this.$refs.saveCandidate.validate()
      if (!isValid) { return }
      const opType = this.saveCandidate.isNew ? 'create' : 'update'
      try {
        const reqObj = {
          id: this.saveCandidate.id,
          data: this.saveCandidate,
        }
        await api[opType](reqObj)
        await this.getList()
        this.closeSaveModal()
        this.notifySuccess1(`${displayPageName}を${msgVars[opType]}しました`)
      } catch (err) {
        const msg = `${displayPageName}の${msgVars[opType]}に失敗しました。` +
          '管理者に連絡してください。'
        this.notifyError1(msg, { err })
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
